import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-600);
`;
export const Description = styled.p `
  color: var(--text-secondary);
  margin: 0;
  font-size: var(--font-size-300);
`;
export const PlaceholderContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-1200) var(--space-600);
  border: 2px dashed var(--border-primary);
  border-radius: var(--radius-brand);
  background: var(--bg-secondary);
  text-align: center;
`;
export const PlaceholderText = styled.h3 `
  color: var(--text-primary);
  margin: 0 0 var(--space-200) 0;
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
`;
export const PlaceholderSubtext = styled.p `
  color: var(--text-secondary);
  margin: 0;
  font-size: var(--font-size-300);
  max-width: 400px;
`;
export const ButtonContainer = styled.div `
  display: flex;
  justify-content: flex-end;
`;
export const SectionsList = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const SectionCard = styled.div `
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const SectionInfo = styled.div `
  flex: 1;
`;
export const SectionName = styled.div `
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-100);
  color: var(--text-primary);
`;
export const SectionDescription = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  margin-bottom: var(--space-200);
`;
export const SectionUrl = styled.div `
  color: var(--text-brand);
  font-size: var(--font-size-300);
  word-break: break-all;
  margin-bottom: var(--space-200);
`;
export const SectionSettingsInfo = styled.div `
  color: var(--icon-secondary);
  font-size: var(--font-size-200);
  font-style: italic;
`;
export const SectionActions = styled.div `
  display: flex;
  gap: var(--space-200);
`;
